import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Components, translate } from 'versafleet-core';
import EditItem from './editItem';
import Header from './header';

const MeasurementEdit = ({
  data = [],
  error = [],
  id = 'vf-task__measurement',
  onFormChange = () => {},
  strings,
}) => {
  const bottomRef = useRef(null);

  const _getInputs = () => {
    const returnData = [];
    let index = 0; // Counter for real data index
    for (let i = 0; i < data.length; i += 1) {
      returnData.push({
        id: data[i].id,
        component: (
          <EditItem
            data={data[i]}
            displayedIndex={index}
            index={i}
            onFormChange={onFormChange}
          />
        ),
      });
      if (!data[i]._destroy) {
        index += 1;
      }
    }

    return returnData;
  };

  return (
    <div className="vf-measurement-edit">
      <Header data={data} />

      <Components.Form.InputGroupList
        error={error}
        inputs={_getInputs()}
      />
      <Components.Button
        iconClassName="versa-add"
        id={`${id}__add-item-button`}
        onClick={() => {
          onFormChange([
            ...data, {
              quantity: '',
              quantity_unit: '',
            },
          ]);
          setTimeout(() => {
            bottomRef.current.scrollIntoView({ behavior: 'smooth' });
          }, 200);
        }}
      >
        {strings.Task.form.buttons.addNewItems}
      </Components.Button>
      <div ref={bottomRef} />
    </div>
  );
};

MeasurementEdit.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    _destroy: PropTypes.bool,
  })),
  error: PropTypes.arrayOf(PropTypes.shape()),
  id: PropTypes.string,
  onFormChange: PropTypes.func,
  strings: PropTypes.shape({
    Task: PropTypes.shape({
      form: PropTypes.shape({
        buttons: PropTypes.shape({
          addNewItems: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

export default translate('')(MeasurementEdit);
